import { UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import WorkoutButtonWithCountdownAndActions from '../../Planner/components/WorkoutButtonWithCountdownAndActions';
import { GymResolver, WorkoutSessionService } from '../../services';
import { ScheduleWorkoutButton } from '../../SummaryDashboard/components/ScheduleWorkoutButton';
import Theme from '../../theme';
import { defaultScale } from '../../utils';
import { getGymTimezone } from '../../utils/gyms';
import { isBookingInOneHour } from '../utils';

interface IProps {
  workoutSessions: UserWorkoutSession[];
  userProfile: UserProfile;
  workoutSessionService: WorkoutSessionService;
  t: (key: string) => string;
  navigation: any;
  analyticsEventName?: string;
  buttonContainer: any;
  buttonStyles: any;
}

export const BookOrJoinWorkoutButton: FunctionComponent<IProps> = ({
  workoutSessions,
  userProfile,
  workoutSessionService,
  t,
  navigation,
  analyticsEventName,
  buttonContainer,
  buttonStyles,
}) => {
  // TODO: nextWorkout logic is dependant on sessions array being sorted this is rigid logic and should be fixed.
  const nextWorkout = workoutSessions && workoutSessions.length && workoutSessions[0];
  const isWorkoutStartingInOneHour = nextWorkout && isBookingInOneHour(nextWorkout);
  const isNextWorkoutHomeWorkout = nextWorkout && UserWorkoutSession.isHomeBooking(nextWorkout, GymResolver.getByName);

  if (isWorkoutStartingInOneHour && Platform.OS === 'web' && isNextWorkoutHomeWorkout) {
    return (
      <View style={{ ...styles.largeHeadingContainer, backgroundColor: Theme.PRIMARY }}>
        <Text style={styles.largeHeading}>
          {t('bookings:joinHomeWorkoutFromApp')}
        </Text>
      </View>
    );
  }

  if (isWorkoutStartingInOneHour) {
    return (
      <View style={buttonContainer}>
        <WorkoutButtonWithCountdownAndActions
          booking={nextWorkout}
          workoutSession={nextWorkout}
          navigation={navigation}
          userProfile={userProfile}
          gymTimezone={getGymTimezone(nextWorkout)}
          workoutSessionService={workoutSessionService}
          roundEdges={true}
          isWorkoutStartingInOneHour={isWorkoutStartingInOneHour}
          buttonStyles={buttonStyles}
        />
      </View>
    );
  }

  return (
    <ScheduleWorkoutButton
      userProfile={userProfile}
      workoutSessionService={workoutSessionService}
      t={t}
      analyticsEvent={analyticsEventName}
      navigation={navigation}
      setupInstantWorkout={true}
      buttonStyles={buttonStyles}
      buttonContainer={buttonContainer}
    />
  );
};

const styles = StyleSheet.create({
  largeHeading: {
    flex: 1,
    color: Theme.WHITE,
    textAlign: 'center',
    fontSize: 18,
    fontFamily: Theme.Custom800,
  },
  largeHeadingContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 45,
    borderRadius: 5,
    padding: 35,
  },
});
